import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ArticlePage from "@/pages/ArticlePage";
import SearchPage from "@/pages/SearchPage";
import DailyDishPage from "@/pages/DailyDishPage";

import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import EditorialQueue from "@/pages/admin/EditorialQueue";
import HumanReview from "@/pages/admin/HumanReview";
import StoryReview from "@/pages/admin/StoryReview";
import Sources from "@/pages/admin/Sources";
import VideoQueue from "@/pages/admin/VideoQueue";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="queue" element={<EditorialQueue />} />
              <Route path="reviews" element={<HumanReview />} />
              <Route path="workflows/:storyId" element={<StoryReview />} />
              <Route path="queue/:id" element={<StoryReview />} />
              <Route path="sources" element={<Sources />} />
              <Route path="videos" element={<VideoQueue />} />
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Route>

            {/* Public */}
            <Route path="/" element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="search" element={<SearchPage />} />
              <Route path="daily-dish" element={<DailyDishPage />} />
              <Route path=":category" element={<CategoryPage />} />
              <Route path="id/:category/:slug" element={<ArticlePage locale="id" />} />
              <Route path=":category/:slug" element={<ArticlePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
